import React from "react";
import { useEffect, useRef, useState, Fragment } from "react";
import { getEmptyImage } from "react-dnd-html5-backend";
import { useDrag } from "react-dnd";

function DragItem({ id, value, url, style, scale, index }) {
  if (scale == null || scale == undefined) {
    scale = 1;
    console.warn("scale is not defined, set scale to 1");
  }
  const [
    {
      isDragging,
      item,
      itemType,
      currentOffset,
      getSourceClientOffset,
      getInitialClientOffset,
      getDifferenceFromInitialOffset,
      getInitialSourceClientOffset,
      getClientOffset,
    },
    drag,
    preview,
  ] = useDrag(() => ({
    type: "image",
    item: { id, value, url, style, index },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      currentOffset: monitor.getSourceClientOffset(),
      getSourceClientOffset: monitor.getSourceClientOffset(),
      getInitialClientOffset: monitor.getInitialClientOffset(),
      getDifferenceFromInitialOffset: monitor.getDifferenceFromInitialOffset(),
      getInitialSourceClientOffset: monitor.getInitialSourceClientOffset(),
      getClientOffset: monitor.getClientOffset(),
    }),
    end: (item, monitor) => {
      const { id: originId, index: originIndex } = item;
      const didDrop = monitor.didDrop();
      const previewEle = previewImage.current;
      previewEle.style.transform = `none`;
      previewEle.style.display = "none";
    },
  }));

  const previewImage = useRef();
  useEffect(() => {
    // preview(getEmptyImage(), { captureDraggingState: true });

    if (getDifferenceFromInitialOffset != null) {
      GetPreview();
    }
  }, [getDifferenceFromInitialOffset]);

  const getPixel = (text) => {
    return parseInt(text.split("px")[0]);
  };

  const GetPreview = () => {
    const previewEle = previewImage.current;

    if (itemType === "image") {
      let top = getPixel(item.style.top);
      let left = getPixel(item.style.left);

      if (currentOffset != null) {
        top = currentOffset.y - top;
        left = currentOffset.x - left;
      }

      if (getDifferenceFromInitialOffset != null) {
        if (isDragging == true) {
          previewEle.src = item.url;
          previewEle.style.display = "block";
          previewEle.style.transform = `translate(${
            getDifferenceFromInitialOffset.x / scale
          }px, ${getDifferenceFromInitialOffset.y / scale}px)`;
        } else {
        }
      }
    }
  };
  console.log("isDragging", isDragging);
  return (
    <>
      <img
        ref={drag}
        src={url}
        style={{
          ...style,
          opacity: isDragging ? "0.4" : style.opacity,
          zIndex: 2,
        }}
      />

      <img
        ref={previewImage}
        style={{
          ...style,
          pointerEvents: "none",
          zIndex: 2,
        }}
      />
    </>
  );
}

export default DragItem;
